'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './directory-edit.routes';

export class DirectoryEditComponent {

  constructor(Auth, dialogs, SettingsService, $uibModal, $state, $stateParams, $location, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.$location = $location;
    this.SettingsService = SettingsService;

    var directoriesConfig = Config.getModuleConfig(Config.Modules.Directories);

    this.contactType = ["phone", "email", "address"];
    this.contactTypeType = directoriesConfig.getBoardAndStaffContactTypes() || ["home","private","work"];

    this.setting = {};
    this.data = {};
    this.sections = [];

    //this.types = directoriesConfig.getBoardAndStaffTypes() || ['Board','Staff'];
    //this.type = this.types[0];

    this.boardAndStuffSettingName = $stateParams.name;
    //this.boardAndStuffSettingName = directoriesConfig.getBoardAndStaffSetting() || 'board-and-staff';

    SettingsService.getByName({name: this.boardAndStuffSettingName}, setting => {
      /*
        {'Board':[], 'Staff':[]}  --> this.type = 'Board'
       */
      this.setting = setting;
      this.data = setting.data;
      this.types = Object.keys(setting.data);
      this.type = this.types[0];
      this.reload();
    }, err => {
    });

    this.sortableOptions = {
        handle: '.handle'
    };

    this.toolbarDefinition = [
      ["bold","italics","underline"],
      ["h3","h4","h5"],
      ["p","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["backgroundColor","fontColor","fontName", "fontSize"]
    ];

  }

  reload() {
    this.sections = this.data[this.type];

    /* Replace all html breaks with newlines, before showing in the editor */
    this.sections.forEach(section => {
      if (section.detail.about) {
        section.detail.about = section.detail.about.split("<br/>").join("\n");
      }
    })

  }

  addSection() {

    this.sections.push({
      head: '',
      sub: '',
      detail: {
        about: '',
        contact: []
      }
    });
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  removePicture(section) {
    delete section.picture;
  }

  removeContact(contacts, idx) {
    contacts.splice(idx,1);
  }

  addContact(contacts) {
    contacts.push({
      contactType: 'phone',
      type: 'Home'
    })
  }

  openAssetBrowserModal(section) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToFileTypes: ["image/jpeg", "image/png"]
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        if (newlySelectedAssets && newlySelectedAssets.length > 0) {
          section.picture = newlySelectedAssets[0]._id;
        }
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal(section) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        if (result && result.length > 0) {
          section.picture = result[0];
        }

      },
      function () { /* cancel */ }
    );

  }

  deleteSection($event, section, idx) {
    $event.stopPropagation();

    var dlg = this.dialogs.confirm("Delete Entry?", "Do you really want to delete the entry '" + section.head + "'?");
    dlg.result.then(() => {
      this.sections.splice(idx,1);
    }, () => {
      // Cancel
    });

  }

  create(form) {

    /* Replace all newlines with html breaks, before saving */
    this.types.forEach(type => {
      this.data[type].forEach(section => {
        if (section.detail.about) {
          section.detail.about = section.detail.about.split(/\n/).join("<br/>");
        }
      })
    });

    var onSuccess = (data) => {
      this.dialogs.notify("Success", "Changes have been saved successfully");
    };

    var onError = err => {
      this.dialogs.error("Error","There has been an error trying to save the settings");
    };

    this.SettingsService.update({id: this.setting._id}, this.setting, onSuccess, onError);
  }

}

export default angular.module('conduuApp.directoryEdit', [uiRouter])
  .config(routes)
  .component('directoryEdit', {
    template: require('./directory-edit.html'),
    controller: DirectoryEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/directory/edit/directory-edit.component.js